module.exports = __webpack_public_path__ + "img/p-4.33725c7e.png";